export default "__VITE_ASSET__be4b7536__"